<template>
  <div class="fileinput text-center">
    <div
      class="fileinput-new thumbnail"
      :class="{ 'img-circle': type === 'avatar' }"
    >
      <img :src="image" alt="preview" />
      <canvas v-show="false" id="canvas" width="1000"></canvas>
    </div>
    <div>
      <span class="btn btn-primary btn-simple btn-file">
        <span class="fileinput-new">{{
          fileExists ? changeText : selectText
        }}</span>
        <input type="hidden" value="" name="" />
        <input
          accept="image/*"
          @change="handlePreview"
          type="file"
          name="..."
          class="valid"
          :multiple="false"
          aria-invalid="false"
        />
      </span>
      <base-button v-if="fileExists" @click="removeFile" round type="danger">
        <i class="fas fa-times"></i> {{ removeText }}
      </base-button>
    </div>
  </div>
</template>
<script>
import swal from "sweetalert2";

export default {
  name: "image-upload",
  props: {
    type: {
      type: String,
      default: "",
      description: 'Image upload type (""|avatar)',
    },
    src: {
      type: String,
      default: "",
      description: "Initial image to display",
    },
    selectText: {
      type: String,
      default: "Select image",
    },
    changeText: {
      type: String,
      default: "Change",
    },
    removeText: {
      type: String,
      default: "Remove",
    },
    formatosValidos: {
      type: Array,
      default: () => [],
    },
    msgError: {
      type: String,
      default: "",
    }
  },
  data() {
    let avatarPlaceholder =
      "https://demos.creative-tim.com/vue-white-dashboard-pro/img/placeholder.jpg";
    let imgPlaceholder =
      "https://demos.creative-tim.com/vue-white-dashboard-pro/img/image_placeholder.jpg";
    return {
      placeholder: this.type === "avatar" ? avatarPlaceholder : imgPlaceholder,
      imagePreview: null,
    };
  },
  computed: {
    fileExists() {
      return this.imagePreview !== null;
    },
    image() {
      return this.imagePreview || this.src || this.placeholder;
    },
  },
  methods: {
    showSwal(type, title, text, typeMsg) {
      if (type === "auto-close") {
        swal({
          title: title,
          text: text,
          type: typeMsg,
          timer: 3000,
          showConfirmButton: false,
        });
      }
    },
    handlePreview(event) {
      let file = event.target.files[0];
      if(!file) return;

      if (!this.formatosValidos.includes(file.type)) {
        this.showSwal('auto-close', 'Formato inválido', this.msgError, 'error');
        return;
      }
      this.imagePreview = URL.createObjectURL(file);

      const canvas = document.getElementById("canvas");
      const ctx = canvas.getContext("2d");
      const img = new Image();
      
      img.src = this.imagePreview;
      let that = this;

      img.onload = function() {
        const imageWidth = img.width;
        const imageHeight = img.height;
        const totalPixels = imageWidth * imageHeight;

        //console.log('totalPixels', totalPixels)

        if (totalPixels > 2073600) { // 2.073.600 pixels (1920x1080)
          const msg = `A imagem excede o tamanho permitido. O máximo é 2.073.600 pixels(Ex: 1920x1080). 
                Tamanho atual: ${imageWidth}x${imageHeight} = ${totalPixels} pixels.`;
          that.showSwal('auto-close', 'Tamanho da Imagem Inválido', msg, 'error');
          that.imagePreview = null;
          return;  
        }
        
        canvas.height = canvas.width * (img.height / img.width);
        const oc = document.createElement("canvas");
        const octx = oc.getContext("2d");
        oc.width = img.width * 0.75;
        oc.height = img.height * 0.75;
        octx.drawImage(img, 0, 0, oc.width, oc.height);
        ctx.drawImage(
          oc,
          0,
          0,
          oc.width * 0.75,
          oc.height * 0.75,
          0,
          0,
          canvas.width,
          canvas.height
        );

        //ja envia convertido
        that.$emit("change", canvas.toDataURL());
      };
    },
    removeFile() {
      this.imagePreview = null;
      this.$emit("change", null);
    },
  },
};
</script>
<style></style>
